import TextField from "@mui/material/TextField";
import { InfoBoxTitle, InfoBoxWrapper } from "../Styled";

interface PurchaseOrderNumberProps {
    value?: string | null;
    setValue: (value: string) => void;
    isView?: boolean;
}

const PurchaseOrderNumber = ({ value, setValue, isView = false }: PurchaseOrderNumberProps) => {
    return (
        <InfoBoxWrapper>
            <InfoBoxTitle>Mã PO</InfoBoxTitle>

            {isView ? (
                <div className="tw-text-base tw-leading-6 tw-text-gray-800">
                    {value?.trim() || (
                        <span className="tw-italic tw-text-gray-400">Chưa có mã PO</span>
                    )}
                </div>
            ) : (
                <TextField
                    value={value || ""}
                    onChange={(event) => setValue(event.target.value)}
                    placeholder="Nhập mã PO của khách hàng"
                    helperText="Tối đa 100 ký tự"
                    inputProps={{ maxLength: 100 }}
                    aria-label="Mã PO"
                    variant="standard"
                    fullWidth
                    sx={{
                        "& .MuiInputBase-root": {
                            fontFamily: "Noto Sans",
                            fontSize: "16px",
                        },
                        "& .MuiFormHelperText-root": {
                            fontFamily: "Noto Sans",
                            marginLeft: 0,
                        },
                    }}
                />
            )}
        </InfoBoxWrapper>
    );
};

export default PurchaseOrderNumber;
